import NotificationSDK from '@nackle/notification-sdk';
import { notificationServiceUrl } from 'endpoints';
import fetch from '../utils/fetch';

export default new NotificationSDK( notificationServiceUrl, fetch );

export const getAppliesToEnum = async () => {
    try {
        const res = await fetch( `${ notificationServiceUrl }/enums`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } );
        const data = await res.json();
        return data;
    } catch ( error ) {
        throw new Error( error );
    }
};

export const getTrigger = async ( id ) => {
    try {
        const res = await fetch( `${ notificationServiceUrl }/triggers/${ id }`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } );
        const data = await res.json();
        return data;
    } catch ( error ) {
        throw new Error( error );
    }
};

export const updateTrigger = async ( id, data ) => {
    try {
        const res = await fetch( `${ notificationServiceUrl }/triggers/${ id }`, {
            method: 'PUT',
            body: JSON.stringify( data ),
            headers: { 'content-type': 'application/json' }
        } );
        const result = await res.json();
        return result;
    } catch ( error ) {
        throw new Error( error );
    }
};

export const createTrigger = async ( data ) => {
    try {
        const res = await fetch( `${ notificationServiceUrl }/triggers`, {
            method: 'POST',
            body: JSON.stringify( data ),
            headers: { 'content-type': 'application/json' }
        } );

        const result = await res.json();

        if ( !res.ok ) {
            throw new Error( result?.reason || res.statusText );
        }

        return result;
    } catch ( error ) {
        throw error;
    }
};

export const deleteTrigger = async ( id ) => {
    try {
        const res = await fetch( `${ notificationServiceUrl }/triggers/${ id }`, {
            method: 'DELETE',
            headers: { 'content-type': 'application/json' }
        } );
        return res.status;
    } catch ( error ) {
        throw new Error( error );
    }
};

export const searchTriggers = async ( data ) => {
    try {
        const params = data ? `internalNameOrCode=${ encodeURI( data ) }` : '';
        const res = await fetch( `${ notificationServiceUrl }/triggers/search?${ params }`, {
            method: 'GET'
        } );
        const result = await res.json();
        return result;
    } catch ( error ) {
        throw new Error( error );
    }
};

export const deleteTriggerContext = async ( triggerId, contextId ) => {
    try {
        const res = await fetch( `${ notificationServiceUrl }/triggers/${ encodeURIComponent( triggerId ) }/triggercontexts/${ encodeURIComponent( contextId ) }`, {
            method: 'DELETE',
            headers: { 'content-type': 'application/json' }
        } );
        return res.status;
    } catch ( error ) {
        throw new Error( error );
    }
};

export const createTriggerContext = async ( triggerId, context ) => {
    try {
        const res = await fetch( `${ notificationServiceUrl }/triggers/${ encodeURIComponent( triggerId ) }/triggercontexts`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify( context )
        } );
        const result = await res.json();
        if ( res.status !== 200 ) {
            throw new Error( result.reason );
        }
        return result;
    } catch ( error ) {
        throw new Error( error );
    }
};

export const getTriggerHierarchies = async ( triggerId ) => {
    try {
        const res = await fetch( `${ notificationServiceUrl }/triggers/${ encodeURIComponent( triggerId ) }/hierarchies`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } );
        const result = await res.json();
        return result;
    } catch ( error ) {
        throw new Error( error );
    }
};

export const getSelectionsFromHierarchies = async ( triggerId, hierarchyId ) => {
    try {
        const res = await fetch( `${ notificationServiceUrl }/triggers/${ encodeURIComponent( triggerId ) }/hierarchies/${ encodeURIComponent( hierarchyId ) }/selections`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } );
        const result = await res.json();
        return result;
    } catch ( error ) {
        throw new Error( error );
    }
};